import { Link } from 'react-router-dom';
import { Product } from '@/lib/api';

const FALLBACK_IMAGE = 'https://readdy.ai/api/search-image?query=Cute%20pastel%20colored%20lifestyle%20accessory%20product%20on%20soft%20cream%20background%2C%20gentle%20shadows%2C%20feminine%20editorial%20product%20photography%2C%20pink%20and%20sage%20tones%2C%20kawaii%20aesthetic%2C%20minimal%20composition&width=400&height=400&seq=roff-prod-fallback-girly&orientation=squarish';

export default function ProductCard({ product }: { product: Product }) {
  const imageUrl = product.imageUrl ?? FALLBACK_IMAGE;

  return (
    <Link to={`/products/${product.slug}`} className="group cursor-pointer block">
      <div className="relative overflow-hidden bg-background-100 aspect-[3/4] rounded-xl mb-4">
        <img
          src={imageUrl}
          alt={product.name}
          className="w-full h-full object-contain object-center transition-transform duration-600 group-hover:scale-105"
        />
        {product.stock === 0 && (
          <span className="absolute top-3 left-3 bg-foreground-700 text-white text-[10px] px-2 py-1 tracking-wider rounded-full"
            style={{ fontFamily: "var(--font-heading)" }}>
            Sold Out
          </span>
        )}
        <div className="absolute inset-0 bg-primary-500/0 group-hover:bg-primary-500/5 transition-colors duration-400"></div>
      </div>
      <div>
        <h3 className="text-sm text-foreground-900 mb-2 leading-snug"
          style={{ fontFamily: "var(--font-body)" }}>
          {product.name}
        </h3>
        <span className="text-base text-foreground-950"
          style={{ fontFamily: "var(--font-heading)" }}>
          ¥{product.price.toLocaleString()}
        </span>
      </div>
    </Link>
  );
}
